import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  id: string;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  id: "",
  data: null,
};

const getTimeKeepingManagerDetailSlice = createSlice({
  name: "getTimeKeepingManagerDetail",
  initialState,
  reducers: {
    setTimeKeepingManagerDetailId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    resetListTimeKeepingManagerDetailId: (state) => {
      state.id = "";
    },
    getTimeKeepingManagerDetailStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getTimeKeepingManagerDetailSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },

    getTimeKeepingManagerDetailFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = null;
    },
    resetTimeKeepingManagerDetail: () => initialState,
  },
});

export const {
  setTimeKeepingManagerDetailId,
  resetListTimeKeepingManagerDetailId,
  getTimeKeepingManagerDetailStart,
  getTimeKeepingManagerDetailSuccess,
  getTimeKeepingManagerDetailFailed,
  resetTimeKeepingManagerDetail,
} = getTimeKeepingManagerDetailSlice.actions;

export default getTimeKeepingManagerDetailSlice.reducer;
